// Fits the longest label ('Campaigns Monitoring', 165px) without ListItemText's noWrap clipping it.
const drawerWidth = 260

export const styles = (theme: any) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarTitle: {
    textDecoration: 'none',
  },
  appBarNoDrawer: {
    paddingLeft: theme.spacing(3),
  },
  drawerPaper: {
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    // Faint tint so the sidebar sits between the white header and the gray canvas.
    backgroundColor: '#fafbfc',
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    // Without this the flex item grows to its content and wide tables never scroll, they just clip.
    minWidth: 0,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    paddingLeft: `calc(${drawerWidth}px + ${theme.spacing(3)})`,
  },
  contentClose: {
    paddingLeft: `calc(${theme.spacing(7)} + ${theme.spacing(3)})`,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: `calc(${theme.spacing(9)} + ${theme.spacing(3)})`,
    },
  },
})
